
import md5 from 'js-md5'
import TitleBox from '@/components/CSS/TitleBox'
export default {
    components: {
        TitleBox
    },
    data() {
        const validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'))
            } else if (value !== this.ruleForm.password) {
                callback(new Error('两次输入密码不一致!'))
            } else {
                callback()
            }
        }
        return {
            passwordType: 'password',
            ruleForm: {
                mobile: '',
                code: '',
                password: '',
                newPassword: ''
            },
            rules: {
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    {
                        pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/,
                        required: true,
                        message: '请输入正确的手机号',
                        trigger: 'blur'
                    }
                ],
                code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
                password: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    {
                        min: 8,
                        max: 16,
                        message: '长度在 8 到 16 个字符',
                        trigger: 'blur'
                    },
                    {
                        pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d\S]{8,16}$|^(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\s])[A-Za-z\d\S]{8,16}$|^(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])[A-Za-z\d\S]{8,16}$|^(?=.*[a-z])(?=.*\d)(?=.*[^\w\s])[A-Za-z\d\S]{8,16}$/,
                        required: true,
                        message: '请输入重新密码',
                        trigger: 'blur'
                    }
                ],
                newPassword: [{ required: true, validator: validatePass, trigger: 'blur' }]
            },
            checked: false,
            loginSate: true,
            regSate: false,
            show: true,
            count: 0,
            timer: null,
            submitLoading: false,
            smsLoading: false,
            verification: true,
        }
    },
    methods: {
        blurPassword(){
            let passwordPattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d\S]{8,16}$|^(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\s])[A-Za-z\d\S]{8,16}$|^(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])[A-Za-z\d\S]{8,16}$|^(?=.*[a-z])(?=.*\d)(?=.*[^\w\s])[A-Za-z\d\S]{8,16}$/;
            this.verification = passwordPattern.test(this.ruleForm.password);
        },
        getCode() {
            const TIME_COUNT = 60
            if (!this.timer) {
                this.count = TIME_COUNT
                this.show = false
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--
                    } else {
                        this.show = true
                        clearInterval(this.timer)
                        this.timer = null
                        this.smsLoading = false
                    }
                }, 1000)
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitLoading = true
                    if (this.ruleForm.password !== this.ruleForm.newPassword) {
                        this.$message.warning('您两次输入的密码不一致，请重新输入')
                        return false
                    } else {
                        let params = {
                            action: {
                                phone: this.ruleForm.mobile.trim(),
                                smsCode: this.ruleForm.code,
                                password: md5(this.ruleForm.password)
                            }
                        }
                        this.$api
                            .forgetPassword(params)
                            .then((res) => {
                                if (res.success) {
                                    this.$message.success('修改成功！')
                                    this.$router.push('/account/userinfo')
                                    this.submitLoading = false
                                } else {
                                    this.submitLoading = false
                                    this.$message.error(res.info)
                                }
                            })
                            .catch(() => {
                                this.submitLoading = false
                            })
                    }
                } else {
                    return false
                }
            })
        },
        sendSms() {
            if (this.ruleForm.mobile === '') {
                this.$message.error('请输入手机号')
                this.$refs.phone.focus()
                return false
            } else {
                this.smsLoading = true
                let data = {
                    action: {
                        phone: this.ruleForm.mobile,
                        smsTemplate: 'MOD'
                    }
                }
                this.$store
                    .dispatch('user/UserSendSms', data)
                    .then((res) => {
                        this.smsLoading = false
                        if (res.success) {
                            this.$message.success('验证码已发送，请注意查收')
                            this.getCode()
                            this.$refs.code.focus()
                            return false
                        } else {
                            this.$message.warning(res.info)
                        }
                    })
                    .catch(() => {
                        this.smsLoading = false
                        this.timer = null
                    })
            }
        },
        showPwd() {
            if (this.passwordType === 'password') {
                this.passwordType = ''
            } else {
                this.passwordType = 'password'
            }
            this.$nextTick(() => {
                this.$refs.password.focus()
            })
        }
    }
}
